import { type FC, type JSX } from 'react';

import styles from './AdBannerWrapper.css';

type TAdBannerWrapperProps = {
  children: JSX.Element;
};

export const AdBannerWrapper: FC<TAdBannerWrapperProps> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
